<template>
  <div id="app">
    <div class="row">
      <div class="col-5 hotel-logo">
        <img src="./assets/wyndham-garden-logo-color.svg" />
        
      </div>
      <div class="col-4"><h1 class="text-right airport-shuttle">Airport Shuttle</h1></div>
      <div class="col-3 dynamic-logo">
        <span>Powered by</span>
        <img src="./assets/dynamic_trackers_logo.png" />
      </div>
    </div>
    <div class="">
      <div class="row">
        <div class="col-5 banner">
          <img class="img-fluid" src="./assets/hotel.png" />
        </div>
        <div class="col-4 eta-info">
          <EtaCounter :stop="stop" />
          <Weather />
        </div>
        <div class="col-3 map">
          <div class="embed-map">
            <GoogleMap :stop="stop" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EtaCounter from "./components/EtaCounter.vue";
import GoogleMap from "./components/GoogleMap.vue";
import Weather from './components/Weather.vue';

export default {
  name: "App",
  components: {
    EtaCounter,
    GoogleMap,
    Weather,
  },
  data() {
    return {
      stop: {
        id: "613a3212137685658d26db99",
        eta: null,
        isInTheStop: false,
        deviceLat: 45.508,
        deviceLng: -73.587
      },
    };
  },
  methods: {
    loadData: async function () {
      let id = "613a321213768539bb26db9d";
      try {
        const response = await this.$http.get(
          "http://eta.dynamictrackers.com:3000/api/1.0/routes/stop/arrival/" +
            id
        );
        // JSON responses are automatically parsed.
        //this.time = response.data;
        this.stop.eta = response.data.arrival.estimatedTime;
        this.stop.isInTheStop = response.data.arrival.isInTheStop;
        this.stop.deviceLat = response.data.arrival.routeDeviceState.deviceState.position.coordinates[1];//.routeDeviceState.deviceState.position.coordinates[0]
        this.stop.deviceLng = response.data.arrival.routeDeviceState.deviceState.position.coordinates[0];//.routeDeviceState.deviceState.position.coordinates[0]

      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.loadData();

    this.interval = setInterval(
      function () {
        this.loadData();
      }.bind(this),
      30000
    );
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  },
};
</script>


<style>
.airport-shuttle{
  font-size: 60px;
}
</style>


